import AccountProfile from 'App/resources/Model/AccountProfile';
import Resource from './Resource';

interface ApplyTemplateRequest {
	template: any;
	accountProfile: any;
	options?: {
		processBody?: boolean;
		processBodyJson?: boolean;
		isStandardTemplate?: boolean;
	};
}

class AccountProfileTemplate extends Resource {
	constructor() {
		super('mail/accountProfileTemplate');
	}

	// Apply account profile colors and fonts to a template
	apply(template: any, accountProfile: AccountProfile, options: ApplyTemplateRequest['options'] = {}) {
		const requestData: ApplyTemplateRequest = {
			template,
			accountProfile,
			options: {
				processBody: true,
				processBodyJson: true,
				isStandardTemplate: true,
				...options
			}
		};

		return this._postRequest('apply', requestData, { methodName: 'apply' }).then(response => response.data);
	}
}

export default new AccountProfileTemplate();
